var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDislikeDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 68,
    viewBox: "0 0 97 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3488_5919)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 57,
    height: 28,
    rx: 14,
    fill: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.75,
    y: 20.75,
    width: 55.5,
    height: 26.5,
    rx: 13.25,
    stroke: "#F42828",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3488_5919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3333 33.3327C31.3333 34.0691 31.9302 34.666 32.6666 34.666C33.7712 34.666 34.6666 33.7706 34.6666 32.666V29.9993C34.6666 28.8948 33.7712 27.9993 32.6666 27.9993C31.9302 27.9993 31.3333 28.5963 31.3333 29.3327V33.3327Z",
    stroke: "#F42828",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3192 36.4631L40.1417 35.8898C39.9962 35.4199 39.9235 35.185 39.9794 34.9995C40.0247 34.8494 40.124 34.72 40.2594 34.6348C40.4268 34.5296 40.6799 34.5296 41.1862 34.5296H41.4555C43.1689 34.5296 44.0255 34.5296 44.4302 34.0225C44.4764 33.9645 44.5176 33.9029 44.5531 33.8382C44.8644 33.2726 44.5105 32.5106 43.8027 30.9866C43.1532 29.5881 42.8284 28.8888 42.2254 28.4772C42.1671 28.4374 42.1071 28.3998 42.0456 28.3646C41.4108 28.0007 40.6242 28.0007 39.051 28.0007H38.7098C36.8039 28.0007 35.8509 28.0007 35.2588 28.5743C34.6667 29.148 34.6667 30.0714 34.6667 31.918V32.5671C34.6667 33.5376 34.6667 34.0228 34.839 34.4669C35.0112 34.911 35.341 35.2762 36.0005 36.0066L38.7282 39.0269C38.7966 39.1027 38.8308 39.1406 38.8609 39.1668C39.1424 39.4118 39.5769 39.3842 39.823 39.1058C39.8494 39.0759 39.8782 39.034 39.9358 38.9503C40.026 38.8193 40.071 38.7538 40.1103 38.6889C40.462 38.1079 40.5684 37.4177 40.4073 36.7626C40.3893 36.6894 40.3659 36.6139 40.3192 36.4631Z",
    stroke: "#F42828",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3488_5919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0013 32C63.5693 32 63.8659 32.6573 63.5233 33.082L63.4726 33.138L59.4726 37.138C59.3578 37.2528 59.2051 37.3217 59.0431 37.3319C58.881 37.3421 58.7209 37.2928 58.5926 37.1933L58.5299 37.138L54.5299 33.138L54.4746 33.0753L54.4386 33.024L54.4026 32.96L54.3913 32.936L54.3733 32.8913L54.3519 32.8193L54.3453 32.784L54.3386 32.744L54.3359 32.706V32.6273L54.3393 32.5887L54.3453 32.5487L54.3519 32.514L54.3733 32.442L54.3913 32.3973L54.4379 32.3093L54.4813 32.2493L54.5299 32.1953L54.5926 32.14L54.6439 32.104L54.7079 32.068L54.7319 32.0567L54.7766 32.0387L54.8486 32.0173L54.8839 32.0107L54.9239 32.004L54.9619 32.0013L63.0013 32Z",
    fill: "#F42828"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3488_5919",
    x: 0,
    y: 0,
    width: 97,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3488_5919"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3488_5919",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3488_5919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(30 26)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3488_5919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(51 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeDropdown);
export default __webpack_public_path__ + "static/media/dislikeDropdown.8135244b9722604c996b31d32389ec89.svg";
export { ForwardRef as ReactComponent };